import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["metadata", "fallback"];
import { getReconnectionConfigByAppId } from '../../reconnectionConfigs';
import { ReconnectButton } from './ReconnectButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const CtaReconnectButton = _ref => {
  let {
      metadata,
      fallback = null
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const appId = (metadata === null || metadata === void 0 ? void 0 : metadata.appId) || 0;
  const status = metadata === null || metadata === void 0 ? void 0 : metadata.status;
  const reconnectionConfig = getReconnectionConfigByAppId(appId);
  const AppReconnectButton = (reconnectionConfig === null || reconnectionConfig === void 0 ? void 0 : reconnectionConfig.reconnectButton) || ReconnectButton;
  const statusesForDisplaying = (reconnectionConfig === null || reconnectionConfig === void 0 ? void 0 : reconnectionConfig.statusesForDisplaying) || [];
  const shouldDisplayReconnectButton = statusesForDisplaying.length === 0 || statusesForDisplaying.includes(status);
  return shouldDisplayReconnectButton ? /*#__PURE__*/_jsx(AppReconnectButton, Object.assign({
    metadata: metadata,
    fallback: fallback
  }, rest)) : fallback;
};